import React, { Fragment } from 'react'
import Picture from '../../components/Picture'
import DemoForm from '../../components/site/Forms/DemoForm'

import './CardsEstrategias.scss'

export default function CardsEstrategias(props) {
    return (
        <Fragment>
            {props.CTA ? (<section className="new-sales-cta">
                <div className="container">
                    <DemoForm trialAndDemo='teste grátis' ctaText />
                </div>
            </section>) : ''}
            <section className="cards-estrategias">
                <div className="container">
                    <h2 className='title'>
                        {props.title}
                    </h2>
                </div>
                <div className="wrapper">
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/forca-vendas/evolucao.png"
                            alt='Recurso de evolução de vendas do força de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                        />
                        <h4 className="card-title">Evolução de vendas</h4>
                        <h5 className='card-description'>Acompanhe objetivos e a evolução das vendas diariamente</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/forca-vendas/positivacao.png"
                            alt='Recurso de positivação de clientes do força de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                        />
                        <h4 className="card-title">Positivação</h4>
                        <h5 className='card-description'>Veja em tempo real quantos clientes compraram de você por período</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/forca-vendas/analise.png"
                            alt='Recurso de mapa de calor de clientes do força de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                        />
                        <h4 className="card-title">Análise por regiões</h4>
                        <h5 className='card-description'>Analise o seu desempenho comercial num mapa por estados e municípios</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/forca-vendas/curva.png"
                            alt='Recurso de curva ABC de clientes do força de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                        />
                        <h4 className="card-title">Curva ABC</h4>
                        <h5 className='card-description'>Saiba quem são os clientes que trazem o maior retorno com a curva ABC</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/forca-vendas/saude.png"
                            alt='Recurso de saúde da carteira de clientes do força de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                        />
                        <h4 className="card-title">Saúde da carteira</h4>
                        <h5 className='card-description'>Monitore a saúde da sua carteira de clientes</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/forca-vendas/conversao.png"
                            alt='Relatório de taxa de conversão do e-commerce do força de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                        />
                        <h4 className="card-title">Conversão do e-commerce</h4>
                        <h5 className='card-description'>Acompanhe as suas vendas e a interação dos clientes com os produtos</h5>
                    </div>
                </div>

            </section>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardsEstrategias/CardsEstrategias.jsx